var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("g", [
    _vm.is_parent
      ? _c(
          "g",
          _vm._l(_vm.node.children, function (child) {
            return _c("Cell", {
              key: child.data.key,
              attrs: {
                "selected-control-id": _vm.selectedControlId,
                depth: _vm.depth + 1,
                node: child,
                scales: _vm.scales,
              },
              on: { "select-node": _vm.select_node },
            })
          }),
          1
        )
      : _vm._e(),
    _vm.depth >= 1
      ? _c("rect", {
          class: _vm.cell_classes,
          style: _vm.cell_style,
          attrs: {
            x: _vm.x,
            y: _vm.y,
            width: _vm.width,
            height: _vm.height,
            rx: _vm.is_selected ? 20 : 0,
          },
          on: {
            click: function ($event) {
              return _vm.select_node(_vm.node)
            },
          },
        })
      : _vm._e(),
    _vm.depth === 1
      ? _c(
          "text",
          {
            attrs: {
              "dominant-baseline": "middle",
              "text-anchor": "middle",
              x: _vm.x + _vm.width / 2,
              y: _vm.y + _vm.height / 2,
            },
          },
          [_vm._v(" " + _vm._s(_vm.node.data.title) + " ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }